export default "__VITE_ASSET__Cxs5_2og__"